import Vue from "vue";
import VeHistogram from "v-charts/lib/histogram.common";
Vue.component(VeHistogram.name, VeHistogram);
